import { get } from "svelte/store";
import { CtrlKeyDown } from "../Stores/userInput.js";
import MapStore from "../Map/Store";
import mapboxgl from "mapbox-gl";

const InputHelper = {
	isTouchScreen: () => {
		return (("ontouchstart" in window) || (navigator.msMaxTouchPoints > 0));
	},
	isCtrlKeyDown: () => {
		return get(CtrlKeyDown);
	},

	/**
	 * @param {*} event Use event.originalEvennt for mouse, and event.touches[0] for mobile/touch.
	 * @param {*} useMap Mapbox Map instance
	 * @returns mapboxgl.Point
	 */
	getMousePos: (event, useMap = null) => {
		// TODO: consider moving to MapHelper? Since it is to do with mouse on map pos.
		const map = (useMap !== null)
			? useMap
			: MapStore.helpers.getMap();
		const canvasContainer = map.getCanvasContainer();
		const rect = canvasContainer.getBoundingClientRect();
		return new mapboxgl.Point(
			event.clientX - rect.left - canvasContainer.clientLeft,
			event.clientY - rect.top - canvasContainer.clientTop
		);
	},
	copyText: (text) => {
		const hiddenCopy = document.createElement("div");
		hiddenCopy.innerHTML = text;
		hiddenCopy.style.position = "absolute";
		hiddenCopy.style.left = "-9999px";

		let currentRange;
		if (document.getSelection().rangeCount > 0) {
			currentRange = document.getSelection().getRangeAt(0);
			if (document.getSelection() && document.getSelection().removeRange) {
				document.getSelection().removeRange(currentRange);
			}
		}
		else {
			currentRange = false;
		}
		document.body.appendChild(hiddenCopy);

		const range = document.createRange();
		range.selectNode(hiddenCopy);
		document.getSelection().addRange(range);
		try {
			document.execCommand("copy");
		}
		catch (err) {
			window.alert("Your browser doesn't support this! Error: " + err);
		}
		document.getSelection().removeRange(range);
		document.body.removeChild(hiddenCopy);

		if (currentRange) {
			document.getSelection().addRange(currentRange);
		}
	}
};

export default InputHelper;
